import { HomeButton } from '@components/home-button/home-button';
import { ScrollToTop } from '@components/scroll-to-top/scroll-to-top';
import { ChildAccountRoutes } from '@routes/child-account-routes';
import { HashRouter } from 'react-router-dom';

export const ChildAccountRoutesWidget = () => (
    // Need to use hash router for SiteCore
    <HashRouter>
        <HomeButton />
        <ScrollToTop />
        <ChildAccountRoutes />
    </HashRouter>
);
